import React, { useContext, useEffect, useRef, useState } from 'react';
import { Avatar, Box, Chip, TextField, Typography } from '@material-ui/core';

import { styles } from './user.style';
import { ProfileContext } from '../../../../services/profile/profile.context';
import { CreateMeetingContext } from '../../../../services/create-meeting/create-meeting.context';
import { UsersListComponent } from './users-list.component';
import { useTheme, withStyles } from '@material-ui/styles';
import { urlConfig } from '../../../../config/urlConfig';

const StyleChip = withStyles((theme) => {
  return {
    outlinedSecondary: {
      color: theme.ui.error,
      border: ` 1px solid ${theme.ui.error}`,
    },
    deleteIconOutlinedColorSecondary: {
      color: theme.ui.error,
      '&:hover': {
        color: '#a40925',
      },
    },
    // deleteIconOutlinedColorSecondary: {
    //   '&:hover': {
    //     backgroundColor: '#a40925',
    //   },
    // },
  };
})(Chip);

export const InvitedUserComponent = ({ functions, states }) => {
  const theme = useTheme();
  const { user = '' } = useContext(ProfileContext);
  const { states: createMeetingStates } = useContext(CreateMeetingContext);
  const { users } = createMeetingStates;
  const [label, setLabel] = useState('');
  const [focused, setFocused] = useState(false);
  const [borderColor, setBorderColor] = useState('rgb(196,196,196)');
  const labelText = 'Guest';
  // const [leftMargin, setLeftMargin] = useState(0);

  const ref = useRef(null);

  const {
    handleChange,
    handleKeyDown,
    handleDelete,
    handleClick,
    addSearchTerm,
  } = functions;

  const { value, error, id, searchList, isEmail, notFound } = states;

  const container = {
    borderColor: !focused ? borderColor : '#f55d21',
    border: !focused ? 1 : 2,
    borderRadius: '3px',
    paddingBottom: label ? '20px' : '0px',
    minHeight: 42,
    height: 'max-content',
    position: 'relative',
  };

  const textField = {
    marginTop: 3,
    position: label && 'absolute',
    top: label ? -11 : 0,
    left: label && 16,
    width: label && 210,
  };

  const checker = (id, users) => {
    //update meeting
    if (id && users) {
      if (users.length === 0) {
        setFocused(false);
        setLabel(labelText);
      } else {
        setLabel('');
        setFocused(true);
      }
    } else if (!id) {
      if (users && users.length === 0 && !value) {
        setLabel(labelText);
        setFocused(false);
      } else {
        setLabel('');
        setFocused(true);
      }
    }
  };

  useEffect(() => {
    checker(id, users);
  }, [id, users]);

  // useEffect(() => {
  //   label ? setLeftMargin(16) : setLeftMargin(0);
  //   value ? setLeftMargin(8) : setLeftMargin(0);
  // } ,[label, value])

  return (
    <>
      <Box
        onMouseEnter={() => setBorderColor('rgba(0, 0, 0, 0.87)')}
        onMouseLeave={() => setBorderColor('rgb(196,196,196)')}
        p={1}
        mt={3}
        {...container}
        onClick={() => {
          !value && ref.current.focus();
        }}
      >
        {focused && label && <div style={styles.head} />}
        {value && <div style={styles.head} />}
        {!label && (
          <div style={styles.label}>
            <Typography
              style={{ paddingLeft: !label && 8 }}
              variant='caption'
              color={focused ? 'primary' : 'textSecondary'}
            >
              Guest
            </Typography>
          </div>
        )}
        {users &&
          user &&
          users.map(
            (item, i) =>
              (item.username !== user.username ||
                item.email !== user.email) && (
                <StyleChip
                  key={i}
                  label={
                    item.fname ? `${item.fname} ${item.lname}` : item.username
                  }
                  // variant='outlined'
                  avatar={<Avatar alt={item.username} src={item.avatar} />}
                  style={{
                    margin: '0 8px 8px 0',
                    maxWidth: 290,
                  }}
                  color={item.isValid ? 'default' : 'secondary'}
                  clickable={true}
                  onClick={(e) => handleClick(item.username, e)}
                  onDelete={() => handleDelete(item.username)}
                />
              )
          )}

        <TextField
          inputRef={ref}
          name='memberEmail'
          placeholder={'Username or email address *'}
          style={textField}
          value={value}
          onKeyDown={handleKeyDown}
          onChange={handleChange}
          onFocus={() => setFocused(true)}
          label={label}
          InputProps={{
            disableUnderline: true,
          }}
          onBlur={() => {
            setFocused(false);
            addSearchTerm(value, true);
          }}
          size='small'
        />
      </Box>

      {value && (
        <UsersListComponent
          value={value}
          addSearchTerm={addSearchTerm}
          searchList={searchList}
          isEmail={isEmail}
          notFound={notFound}
          error={error}
        />
      )}
    </>
  );
};
